import { getSpacingTop } from "../Box/spacing";
import { getSystemFontFamilyMap } from "./fontFamily";

const fontConfigToFontPositionMap = config => {
  const baselineFromTop = config.ascender;
  return {
    baseline: baselineFromTop,
    ascender: baselineFromTop - config.ascender,
    capHeight: baselineFromTop - config.capHeight,
    capCenter: baselineFromTop - config.capHeight / 2,
    xHeight: baselineFromTop - config.xHeight,
    xCenter: baselineFromTop - config.xHeight / 2,
    descender: baselineFromTop - config.descender
  };
};

class FontMetrics {
  constructor(config) {
    this.config = void 0;
    this.position = void 0;
    this.config = config;
    this.position = fontConfigToFontPositionMap(config);
  }

  positionFor(position, {
    size,
    lineHeight,
    padding
  }) {
    const {
      unitsPerEm,
      ascender,
      descender
    } = this.config;
    const unitsPerLine = ascender - descender;
    const emsPerLine = unitsPerLine / unitsPerEm;
    const contentArea = size * emsPerLine;
    const offset = (lineHeight - contentArea) / 2;
    return getSpacingTop(padding) + offset + size * this.position[position] / unitsPerEm;
  }

  configFor(configKey, size) {
    return this.config[configKey] * size / this.config.unitsPerEm;
  }

}

export default FontMetrics;
const metricsFallback = new FontMetrics({
  unitsPerEm: 2048,
  ascender: 1920,
  descender: -512,
  lineGap: 0,
  xHeight: 1024,
  capHeight: 1440
});
const metricsSanFranciscoText = new FontMetrics({
  unitsPerEm: 2048,
  ascender: 1980,
  descender: -432,
  lineGap: 0,
  xHeight: 1078,
  capHeight: 1443
});
const fontFamilyMetrics = {
  '-apple-system': metricsSanFranciscoText,
  BlinkMacSystemFont: metricsSanFranciscoText,
  Consolas: new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1521,
    descender: -527,
    lineGap: 350,
    xHeight: 1004,
    capHeight: 1307
  }),
  'Helvetica Neue': new FontMetrics({
    unitsPerEm: 1000,
    ascender: 952,
    descender: -213,
    lineGap: 28,
    xHeight: 517,
    capHeight: 714
  }),
  Menlo: new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1556,
    descender: -492,
    lineGap: 410,
    xHeight: 1120,
    capHeight: 1493
  }),
  Roboto: new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1900,
    descender: -500,
    lineGap: 0,
    xHeight: 1082,
    capHeight: 1456
  }),
  'Segoe UI': new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1491,
    descender: -431,
    lineGap: 269,
    xHeight: 1024,
    capHeight: 1434
  }),
  Ubuntu: new FontMetrics({
    unitsPerEm: 1000,
    ascender: 772,
    descender: -185,
    lineGap: 28,
    xHeight: 520,
    capHeight: 693
  })
};
export const getFontMetrics = typeface => {
  const fontFamilyMap = getSystemFontFamilyMap();
  const fontFamily = fontFamilyMap[typeface]; // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.

  return fontFamilyMetrics[fontFamily] || metricsFallback;
};